import { useMinerContext } from "../MinerContext";
import { dev } from "@utils/dev";
import { MinerActions } from "../minerReducer";
import { GetMinerInfo, IAdminMinerInfo, IAdminMinerTable } from "@services/getMinerInfo";
import { ALLOW_WEEKDAY_PLANS } from "../../../../../config";
import adjustInstalledDateResponse from "@utils/adjustInstalledTimeResponse";
import { RecordResponse } from "@services/http/responses/BaseResponse";
import { useAuth } from "@utils/hooks/useAuth";
import useApiRequests from "@services/http/useApiRequest";
import { useRefreshingStoredMiners } from "@utils/hooks/useStoredMiners";
import { useFirstRender } from "@utils/hooks/useFirstRender";
import { useEffect, useState } from "react";

function getInitialMoreState(minerId: number): boolean {
  const result = localStorage.getItem(`miner-row-${minerId}`);
  if (result === "1") {
    return true;
  }
  return false;
};

export default function useMinerRowMoreControl() {

  const firstRender = useFirstRender();
  const auth = useAuth();
  const { miner, updateMiner } = useMinerContext();
  const requests = useApiRequests();
  const [isLoading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(getInitialMoreState(miner.id));
  const isRefreshing = useRefreshingStoredMiners();

  async function toggleMiner() {
    if (isOpen) {
      localStorage.removeItem(`miner-row-${miner.id}`);
      setOpen(false);
    } else {
      localStorage.setItem(`miner-row-${miner.id}`, "1");
      setOpen(true);
      await loadMinerInfo();
    }
  }

  const loadMinerInfo = async () => {
    try {
      setLoading(true);
      const request = new GetMinerInfo(miner.id.toString(), auth.isAdmin);
      const result = await requests.enqueueSilent<
        RecordResponse<IAdminMinerInfo>
      >(request);
      if (result) {
        if (result.Record.installed) {
          result.Record.installed = adjustInstalledDateResponse(+result.Record.installed) as unknown as string; // потому что на самом деле с сервера приходит number
        }
        if (!ALLOW_WEEKDAY_PLANS) {
          const res = {
            ...result.Record,
            plan: {
              ...result.Record.plan,
              schedule: result.Record.plan.schedule.filter(sch => sch.day.length === "DD/MM/YYYY".length)
            }
          }
          updateMiner(res);
        } else {
          updateMiner(result.Record);
        }
      }
    } catch (e) {
      dev.error("Error: loadMinerInfo", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (firstRender && isOpen) loadMinerInfo();
    if (isOpen && isRefreshing) loadMinerInfo();
  }, [isRefreshing]);

  return {
    isOpen,
    isLoading,
    minerId: miner.id,
    hasErrors: !!miner.has_errors,
    toggleMiner,
  }
}